import { useId } from 'react';
import { APP_NAME } from '@easiibill/shared';
import { cn } from '@/lib/utils';

/** A receipt with a torn edge on a blue tile. Keep in sync with public/favicon.svg. */
export function BrandMark({ className }: { className?: string }) {
  // Unique per instance: a gradient referenced from a hidden (display: none) copy does not paint.
  const gradient = `eb-mark-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  return (
    <svg viewBox="0 0 64 64" className={cn('size-8 shrink-0', className)} aria-hidden>
      <defs>
        <linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3b82f6" />
          <stop offset="1" stopColor="#1d4ed8" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill={`url(#${gradient})`} />
      <path
        d="M21 14h22a2 2 0 0 1 2 2v34l-3.25-2.5L38.5 50l-3.25-2.5L32 50l-3.25-2.5L25.5 50l-3.25-2.5L19 50V16a2 2 0 0 1 2-2z"
        fill="#fff"
      />
      <path d="M25 24h14M25 30.5h14M25 37h8" stroke="#2563eb" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export function BrandLogo({ className, size = 'md' }: { className?: string; size?: 'sm' | 'md' | 'lg' }) {
  const text = { sm: 'text-[16px]', md: 'text-[18px]', lg: 'text-[22px]' }[size];
  const mark = { sm: 'size-7', md: 'size-8', lg: 'size-10' }[size];
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <BrandMark className={mark} />
      <span className={cn('font-display font-bold tracking-tight text-ink', text)} aria-hidden>
        easii<span className="text-brand-600 dark:text-brand-400">bill</span>
      </span>
      <span className="sr-only">{APP_NAME}</span>
    </span>
  );
}
